/**
 * Format email address to show first 4 and last 6 characters of local part + domain
 */
export function formatEmailForDisplay(email: string): string {
  const [localPart, domain] = email.split("@");
  if (!domain || !localPart) return email;
  
  // Show first 4 and last 6 characters of local part + domain
  if (localPart.length <= 10) {
    return `${localPart}@${domain}`;
  }
  
  const first4 = localPart.slice(0, 4);
  const last4 = localPart.slice(-4);

  return `${first4}...${last4}@${domain}`;
}

/**
 * Get display name with partial email
 */
export function getDisplayNameWithPartialEmail(
  name: string | null,
  email: string,
): string {
  const partialEmail = formatEmailForDisplay(email);
  if (name) {
    return `${name} (${partialEmail})`;
  }
  return partialEmail;
}
